module.exports = __webpack_public_path__ + "assets/img/49.70949b15.png";